import styled from 'styled-components'

export const AnimatedAvatarSvg = styled.div`
  height: 100%;
  width: 100%;

  svg {
    path:first-of-type {
      opacity: 0;
      animation: fadeInOut 1.6s 0.4s ease-in-out infinite;
    }
  }

  @keyframes fadeInOut {
    0% {
      //0ms
      opacity: 0;
    }
    25% {
      //400ms
      opacity: 0;
    }
    50% {
      //800ms
      opacity: 1;
    }
    75% {
      //1200ms
      opacity: 1;
    }
    100% {
      //1600ms
      opacity: 0;
    }
  }
`
